<template>
    <div id="question-zone" class="question-zone-center">
        <div id="question-result">
            <img class="animated fadeIn" src="@/assets/svg/graduation-cap.svg" alt="Toque universitaire,">
            <h1 class="animated fadeIn">Merci pour votre <br> participation au questionnaire !</h1>
            <button class="animated fadeIn" @click="emitGoPlan">
                Suivant →
            </button>
        </div>
    </div>
</template>
<script>

    export default {
        name: 'QuestionResult1',
        methods: {
            emitGoPlan() {
                this.$emit('go')
            }
        },

    }
</script>

<style lang="scss" scoped>
    @import "../../assets/css/default";

    #question-result {
        text-align: center;
        img {
            width: 50%;
            height: auto;
            animation-delay: 0.5s;
        }
        h1 {
            animation-delay: 1.5s;
            font-weight: 400;
            line-height: 1.4;
        }
        button {
            animation-delay: 2.5s;
            border: 1px solid #fff;
            background-color: transparent;
            color: #fff;
            padding: 20px 30px;
            border-radius: 50px;
            font-size: 1.5rem;
            background-color: #2235a1;
            font-weight: bold;
            margin-top: 5%;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            transition: all 0.5s cubic-bezier(.25, .8, .25, 1);
            cursor: pointer;
            outline: none;
            overflow: hidden;
            position: relative;
            text-align: left;

            &:hover {
                box-shadow: 6px 9px 10px 0px rgba(0, 0, 0, 0.2);
                border: 1px solid #2235a1;
                color: #fff;
            }

        }
    }

</style>